const KEY = "bible_reading_progress";

// 📅 formato YYYY-MM-DD
const todayKey = () => new Date().toISOString().slice(0, 10);

// ✔ marcar como leído
export const markAsReadToday = () => {
  const data = JSON.parse(localStorage.getItem(KEY) || "{}");
  data[todayKey()] = true;
  localStorage.setItem(KEY, JSON.stringify(data));
};

// ❓ verificar si ya leyó hoy
export const isReadToday = () => {
  const data = JSON.parse(localStorage.getItem(KEY) || "{}");
  return !!data[todayKey()];
};